import Navigation from "@/components/Navigation";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import OptimizedImage from "@/components/OptimizedImage";

const Facials = () => {
  const [mainImage, setMainImage] = useState<string>("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFacialImages = async () => {
      try {
        console.log('Fetching facial images from Supabase storage...');
        const { data, error } = await supabase
          .storage
          .from('face_images')
          .list();

        if (error) {
          console.error('Error fetching facial images:', error);
          return;
        }

        console.log('Successfully fetched facial images:', data);

        if (data && data.length > 0) {
          const { data: { publicUrl } } = supabase
            .storage
            .from('face_images')
            .getPublicUrl(data[0].name);
          
          setMainImage(publicUrl);
        }
      } catch (error) {
        console.error('Unexpected error fetching facial images:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchFacialImages();
  }, []);

  return (
    <div className="min-h-screen">
      <Navigation />
      <div className="pt-24 px-6">
        <div className="max-w-7xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-serif mb-8">Medical-Grade Facials</h1>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div>
              {loading ? (
                <div className="w-full h-[400px] bg-gray-200 animate-pulse rounded-lg" />
              ) : (
                <OptimizedImage
                  src={mainImage}
                  alt="Medical-Grade Facials"
                  className="w-full h-[400px] object-cover rounded-lg shadow-lg"
                />
              )}
            </div>
            <div>
              <p className="text-lg mb-6">
                Experience transformative results with our medical-grade facial treatments. Our expert estheticians customize each facial to address your specific skin concerns and goals.
              </p>
              <div className="space-y-6">
                <div>
                  <h3 className="text-xl font-semibold mb-2">Treatment Benefits</h3>
                  <p>Deep cleansing, exfoliation, and nourishment for optimal skin health.</p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Customization</h3>
                  <p>Tailored treatments for acne, aging, pigmentation, and more.</p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Results</h3>
                  <p>Immediate glow with progressive improvements in skin texture and tone.</p>
                </div>
              </div>
              <a
                href="https://na02.patientnow.com/a/EVOLVEDYOU"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block bg-primary text-white px-8 py-3 rounded-full text-lg hover:bg-primary/90 transition-colors mt-8"
              >
                Book Now
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Facials;